import { API, graphqlOperation } from "aws-amplify"
import { GET_HISTORY, SUBSCRIBE_NEW } from "../ActionTypes"
import { getHistory } from "../graphql/queries"
import { addEmailSubscribe } from "../graphql/mutation"

export const get_history = data => ({
	type: GET_HISTORY,
	payload: API.graphql(graphqlOperation(getHistory(data)))
})

export const subscribe_new = email => ({
	type: SUBSCRIBE_NEW,
	payload: API.graphql(graphqlOperation(addEmailSubscribe(email)))
})
